import createStore from '../../../redux/factories/crud/crudFactory';
import documentDetailReducers from '../redux/reducers';
import documentDetailSaga from '../redux/saga';
import {Endpoint} from '../constants'

const {actionTypes, actions, reducers, sagas} = createStore(Endpoint.Document);

export {actionTypes, actions, reducers, sagas, documentDetailReducers, documentDetailSaga};

export const dependentDocument = createStore(`${Endpoint.Document}/dependent-document`);
export const linkedDocument = createStore(`${Endpoint.Document}/linked-document`);
